// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "348905ce13a34594024aca6bc2a1e8e9" + ".js";
};